/*Global Dependencies*/
import { FC, useEffect, useState, useRef } from "react";
import { Select, Spin } from "antd";

/*Local Dependencies*/
import CustomTooltip from "@pages/tool-tip";
import { EditOutlined } from "@ant-design/icons";
import membersService from "@services/members.service";
import memberDetailsService from "@services/memberDetails.service";
import {reactPlugin, withAITracking } from "../../../../../appInsights";
import "./UpdateTextWithDropdown.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";

interface UpdateTextWithDropdownProps {
  atrributeName?: string;
  displayText: string;
  dropDownKeyToFetch?: string;
  onDisplayTextChange: any;
  onChange?: any,
  handleSelectChangeManually?: boolean;
  loadingState?: boolean;
  placeHolder?: string;
  currentState?: any;
  onEditButtonClick?: any;
  defaultFieldState?: any
  customDropdownData ?: any;
  disabled ?: boolean;
  showEditText?: boolean;
  showEditTextString?: string;
  setNotesModal ?:  (x: any) => void;
  dropdownSize ?: string;
  textClassName ?: string;
}

export enum FieldState {
  Dropdown = "DROPDOWN",
  Text = "TEXT",
}

const UpdateTextWithDropdown: FC<UpdateTextWithDropdownProps> = ({
  atrributeName = "",
  displayText,
  dropDownKeyToFetch,
  onDisplayTextChange,
  onChange,
  handleSelectChangeManually = false,
  loadingState = false,
  placeHolder = "Select Attribute",
  currentState,
  onEditButtonClick,
  defaultFieldState = FieldState.Text,
  customDropdownData,
  disabled,
  showEditText,
  showEditTextString,
  setNotesModal,
  dropdownSize,
  textClassName
}) => {
  const [currentFieldState, setCurrentFieldState] = useState<FieldState>(FieldState.Text);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentFieldValue, setCurrentFieldValue] = useState<string>(displayText);
  const wrapperRef = useRef<any>(null);
  const [dropDownData, setDropDownData] = useState();

  /**
   * To change the state from Dropdown to text or vice-versa.
   */
  useEffect(() => {
    console.log("UpdateTextWithDropdown.useEffect2")
    if (currentState) {
      currentState(currentFieldState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFieldState]);

  useEffect(() => {
    console.log("UpdateTextWithDropdown.useEffect3")
    setCurrentFieldValue(displayText);
    if (displayText) {
      setCurrentFieldValue(displayText);
    }
  }, [displayText]);

  useEffect(() => {
    console.log("UpdateTextWithDropdown.useEffect4")
    setLoading(loadingState);
  }, [loadingState]);

  useEffect(() => {
    console.log("UpdateTextWithDropdown.useEffect5")
    if (defaultFieldState !== FieldState.Text) {
      setCurrentFieldState(FieldState.Dropdown)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFieldState])

  /**
   * If dropDownKeyToFetch is passed as props then fetching dropdown data in here.
   * If dropDownKeyToFetch not passed as props then we should pass customDropdownData.
   */
  useEffect(() => {
    if (customDropdownData) {
      setDropDownData(customDropdownData);
    }
    if (dropDownKeyToFetch) {
      memberDetailsService.fetchAttributeDropdown(dropDownKeyToFetch).subscribe({
        next: (response: any) => {
          setDropDownData(response.data.data.data);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }, [customDropdownData, dropDownKeyToFetch])

  return (
    <div className="update-text-container">
      <div>
        {currentFieldState === FieldState.Text && (
          <TextField
            loading={loading}
            currentFieldValue={currentFieldValue}
            setCurrentFieldState={setCurrentFieldState}
            onEditButtonClick={onEditButtonClick}
            disabled={disabled}
            handleSelectChangeManually
            showEditText={showEditText}
            showEditTextString={showEditTextString}
            setNotesModal={setNotesModal}
            textClassName={textClassName}
          />
        )}
      </div>
      <div>
        {currentFieldState === FieldState.Dropdown && (
          <DropDownField
            loading={loading}
            dropdownData={dropDownData}
            currentFieldValue={currentFieldValue}
            wrapperRef={wrapperRef}
            setCurrentFieldState={setCurrentFieldState}
            currentFieldState={currentFieldState}
            setLoading={setLoading}
            setCurrentFieldValue={setCurrentFieldValue}
            atrributeName={atrributeName}
            onDisplayTextChange={onDisplayTextChange}
            onChange={onChange}
            handleSelectChangeManually={handleSelectChangeManually}
            placeHolder={placeHolder}
            dropdownSize={dropdownSize}
          />
        )}
      </div>
    </div>
  );
};

export default withAITracking(reactPlugin, UpdateTextWithDropdown);

interface TextFieldProps {
  loading: boolean;
  currentFieldValue: string;
  setCurrentFieldState: any;
  onEditButtonClick?: any;
  disabled ?: boolean;
  handleSelectChangeManually?: boolean;
  showEditText?: boolean;
  showEditTextString?: string;
  setNotesModal ?:  (x: any) => void;
  textClassName ?: string
}

export const TextField: FC<TextFieldProps> = ({ loading, currentFieldValue, setCurrentFieldState, onEditButtonClick , disabled, handleSelectChangeManually = false, showEditText = false, showEditTextString = "" , setNotesModal , textClassName}) => {
  return (
      <div className="update-text-container__text-field--label">
        <div className={`update-text-container__text-field--icon ${showEditText && currentFieldValue === null ? 'dnone' : ''}`}>
          <CustomTooltip
            toolTipvalue={currentFieldValue}
            children={
              <Spin spinning={loading} indicator={<HealthemSpinner />}>
                <span className={`${textClassName ? textClassName : 'update-text-container__text-field--value'} ${setNotesModal ? 'ellipsis' : ''}`}>
                  {currentFieldValue?.length > 25 ? currentFieldValue?.slice(0,25) + "..." : currentFieldValue}
                </span>
              </Spin>
            }
          />
        </div>
        <CanEdit>
        <div
          style={{cursor: "pointer"}}
          onClick={() => {
            if(setNotesModal){
              setNotesModal(true)
            } else if (!disabled) {
              setCurrentFieldState(FieldState.Dropdown);
              if(onEditButtonClick){
                onEditButtonClick();
              }
            }
          }}
        >
          {showEditText && currentFieldValue === null && <span className={` ${disabled ? "disabled grey-color" : "color-for--generic_options"}`} style={{ paddingRight: "5px"}}>{showEditTextString}</span>}
          <EditOutlined className={` ${disabled ? "disabled grey-color" : "color-for--generic_options"}`} />
        </div>
        </CanEdit>
      </div>
  );
};

interface DropDownFieldProps {
  loading: boolean;
  dropdownData: any;
  currentFieldValue: string;
  wrapperRef: any;
  setCurrentFieldState: any;
  currentFieldState: any;
  setLoading: any;
  setCurrentFieldValue: any;
  atrributeName: string;
  onDisplayTextChange: any;
  onChange?: any;
  handleSelectChangeManually?: boolean;
  placeHolder: string;
  dropdownSize ?: any;
}

export const DropDownField: FC<DropDownFieldProps> = ({
  dropdownData,
  currentFieldValue,
  wrapperRef,
  setCurrentFieldState,
  currentFieldState,
  setCurrentFieldValue,
  setLoading,
  atrributeName,
  onDisplayTextChange,
  onChange,
  handleSelectChangeManually = false,
  placeHolder,
  dropdownSize
}) => {
  // To Autofocus dropdown
  useEffect(() => {
    console.log("UpdateTextWithDropdown.DropDownField.useEffect1")
    if (currentFieldState === FieldState.Dropdown) {
      wrapperRef?.current?.focus();
    }
  }, [currentFieldState, wrapperRef]);

  const handleDropDownChange = (value: string, option: any) => {
    console.log("UpdateTextWithDropdown.DropDownField.handleDropDownChange")
    setCurrentFieldValue(value);
    setCurrentFieldState(FieldState.Text);

    if (handleSelectChangeManually) {
      onDisplayTextChange(value);
      if(onChange) {
        onChange(option)
      }
    } else {
      setLoading(true);
      updateAttribute(value, option);
    }
  };

  const updateAttribute = (value: string, option: any) => {
    console.log("UpdateTextWithDropdown.DropDownField.updateAttribute")
    const cMember = membersService?.getCurrentMember;
    if (cMember && cMember?.patient_id) {
      const patient_id = parseInt(cMember?.patient_id);
      const care_manager_id = parseInt(cMember?.care_manager_id);

      const payLoad = {
        attrib_name: atrributeName,
        attrib_value: value,
        attri_id_value: option.key,
        patient_id,
        care_manager_id,
      };
      memberDetailsService.updateSelectedAttribute(payLoad).subscribe({
        next: (response: any) => {
          onDisplayTextChange(value);
          if(onChange) {
            onChange(option)
          }
          setLoading(false);
          console.log(response);
        },
        error: (error) => {
          setLoading(false);
          console.log(error);
        },
      });
    }
  };

  return (
    <>
      <Select
        showSearch
        placeholder={placeHolder}
        optionFilterProp="children"
        onChange={(value, option) => {
          handleDropDownChange(value, option);
        }}
        onSearch={() => {}}
        filterOption={(input, option: any) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        options={dropdownData}
        listHeight={100}
        listItemHeight={100}
        value={currentFieldValue}
        size={dropdownSize ? dropdownSize : "large"}
        className={"w-97per"}
        ref={wrapperRef}
        onBlur={() => {
          setCurrentFieldState(FieldState.Text);
        }}
      />
    </>
  );
};
